(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.mplightbox = {
    attach: function (context, settings) {

      let placeholder = $('div[data-lightbox-tag]');

      $(once('dataLightBoxTag', '[data-lightbox-tag]', context)).each(function(){
        let tag = $(this).attr('data-lightbox-tag'),
          trigger = $('a[href="#' + tag + '"]'),
          lightbox = $(this).clone()
        ;
        lightbox.removeClass('hidden')
        let message = lightbox.html();
        trigger.on('click', function(e){
          e.preventDefault();
          e.stopPropagation();
          Drupal.showModal({
            message,
            className: 'mp-modal__lightbox',
            size: null
          })
        });
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
